module.exports = __webpack_public_path__ + "static/img/1.3ede612.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/1.gif
// module id = jKUr
// module chunks = 1